import {
  fetchResearch,
  fetchResearchItems,
  fetchResearchReviewSessions,
  fetchResearchStatistics,
  makeFilterQueryParams,
} from '@/organisation/api';
import {
  convertArrayToObject,
  copyObject,
} from '@/common/utils/objects';
import { DASHBOARD_FILTERS } from '@/organisation/constants';

const localState = () => ({
  research: null,
  researchItems: [],
  filters: copyObject(DASHBOARD_FILTERS),
  data: {
    sessions: [],
    answersByResearchItem: {},
    statistics: {},
  },
  loading: {
    research: false,
    researchItems: false,
    sessions: false,
    statistics: false,
  },
});

const mapAnswersByResearchItem = (sessions) => {
  const answersByResearchItem = {};
  let newAnswer;
  sessions.forEach((session) => {
    session.answers.forEach((answer) => {
      newAnswer = copyObject(answer);
      newAnswer.province = session.province;
      newAnswer.reviewed = session.reviewed;
      if (newAnswer.research_item_id in answersByResearchItem) {
        answersByResearchItem[newAnswer.research_item_id].push(newAnswer);
      } else {
        answersByResearchItem[newAnswer.research_item_id] = [newAnswer];
      }
    });
  });
  return answersByResearchItem;
};

const actions = {
  async fetchResearch(state, researchUuid) {
    state.commit('setResearch', null);
    state.commit('setResearchLoading', true);
    const response = await fetchResearch(researchUuid);
    if (response.status === 200) {
      state.commit('setResearch', response.data);
    }
    state.commit('setResearchLoading', false);
    return response;
  },
  async fetchResearchItems(state, researchUuid) {
    state.commit('setResearchItems', []);
    state.commit('setResearchItemsLoading', true);
    const response = await fetchResearchItems(researchUuid);
    if (response.status === 200) {
      state.commit('setResearchItems', response.data);
    }
    state.commit('setResearchItemsLoading', false);
    return response;
  },
  async fetchResearchReviewSessions(state, researchUuid) {
    state.commit('setResearchReviewSessionsLoading', true);
    const response = await fetchResearchReviewSessions(
      researchUuid,
      makeFilterQueryParams(state.getters.filters),
    );
    if (response.status === 200) {
      state.commit('setResearchReviewSessions', response.data);
    } else {
      state.commit('setResearchReviewSessions', []);
    }
    state.commit('setResearchReviewSessionsLoading', false);
  },
  async fetchResearchStatistics(state, researchUuid) {
    state.commit('setResearchStatisticsLoading', true);
    const response = await fetchResearchStatistics(
      researchUuid,
      makeFilterQueryParams(state.getters.filters),
    );
    if (response.status === 200) {
      state.commit('setResearchStatistics', response.data);
    } else {
      state.commit('setResearchStatistics', {});
    }
    state.commit('setResearchStatisticsLoading', false);
  },
};

const getters = {
  data(state) {
    return state.data;
  },
  filters(state) {
    return state.filters;
  },
  research(state) {
    return state.research;
  },
  researchItems(state) {
    return state.researchItems;
  },
  loadingResearch(state) {
    return state.loading.research;
  },
  loadingResearchItems(state) {
    return state.loading.researchItems;
  },
  loadingResearchStatistics(state) {
    return state.loading.statistics;
  },
  loadingResearchReviewSessions(state) {
    return state.loading.sessions;
  },
};

const mutations = {
  setResearch(state, research) {
    state.research = research;
  },
  setResearchLoading(state, loading) {
    state.loading.research = loading;
  },
  setResearchItemsLoading(state, loading) {
    state.loading.researchItems = loading;
  },
  setResearchReviewSessionsLoading(state, loading) {
    state.loading.sessions = loading;
  },
  setResearchStatisticsLoading(state, loading) {
    state.loading.statistics = loading;
  },
  setResearchItems(state, researchItems) {
    state.researchItems = researchItems;
  },
  setResearchReviewSessions(state, researchReviewSessions) {
    state.data.sessions = researchReviewSessions.map((session) => ({
      ...session,
      ...{ answerDict: convertArrayToObject(session.answers, 'research_item_id') },
    }));
    state.data.answersByResearchItem = mapAnswersByResearchItem(researchReviewSessions);
  },
  setResearchStatistics(state, researchStats) {
    state.data.statistics = researchStats;
  },
  resetFilters(state) {
    state.filters = copyObject(DASHBOARD_FILTERS);
  },
};

export default {
  namespaced: true,
  state: localState,
  getters,
  actions,
  mutations,
};
